import React from 'react'

// Styles
import './styles.scss'

// Icons
import IconComingSoon from './images/iconComingSoon'

export default () => {
  return (
    <div className={'coming-soon'}>
      <div className={'coming-soon__title'}>
        СТРАНИЦА
        <br />В РАЗРАБОТКЕ
      </div>
      <IconComingSoon />
    </div>
  )
}
